import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const UserPrivateRoute = ({ children }) => {
  const { isUserAuthenticated } = useAuth();
  const storedAuth = JSON.parse(localStorage.getItem('isUserAuthenticated'));

  return storedAuth ? children : <Navigate to="/login_user" />;
};

export default UserPrivateRoute;
